interface PathsInterface {
  dashboard: string;
  help: string;
  media: string;
  mediaSingle: string;
  login: string;
  rebooting: string;
  rebootingUpgrade: string;
  security: string;
  settings: string;
  streaming: string;
  stats: string;
  statsfull: string;
  test: string;
}

export const MakitoPaths: PathsInterface = {
  dashboard: '/',
  help: '/help',
  login: '/login',
  media: '/media/:page?', // page is either "recordings" or "logos"
  mediaSingle: '/media/:page/:id',
  rebooting: '/rebooting',
  rebootingUpgrade: '/rebooting-upgrade',
  security: '/security/:page?',
  settings: '/settings/:page?',
  streaming: '/streaming/:page?',
  stats: '/streaming/:page/stats/:id',
  statsfull: '/streaming/:page/stats-full/:id',
  test: '/test/*',
};

export const defaultRoute = '/';
